<app-mrp-scrolltop></app-mrp-scrolltop>

<!-- main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">

        <div>
          <img class="hero-header-img" src="assets/images/issues/countyconvention.png" alt="County Convention">
        </div>


        <div class="right-menu">
          <mat-form-field appearance="fill">
            <mat-label>Tools...</mat-label>
            <mat-select (selectionChange)="onRouteSelect($event.value)">
              @for (routeOption of delegateroutes; track routeOption) {
              <mat-option [value]="routeOption.path">
                {{ routeOption.label }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>


        <div class="col-12-large">

          <h4><b>County Convention</b></h4>
          <p>A precinct delegate is officially a <strong>"Delegate to County Convention".</strong> What that means is
            that you are a representative of your precinct to act on their behalf at county conventions.
          </p>
          <p>It is therefore quite important to understand how a county convention functions, and what your role is in
            order that you can participate properly.
          </p>

        </div>

        <div class="col-12-large ">
          <p>By law, there are four county conventions every two years. And by law, each delegate serves a 2-year term.
          </p>
          <p>Three county conventions are for electing delegates and alternates to attend state convention which are the
            Fall Convention, Winter Convention & Spring Convention.
          </p>
          <p>One county conventions is for electing the County Executive Committee. This occurs at the November
            Convention.
          </p>

        </div>

      </div>
    </div>
  </div>
</section>

<!-- section 2 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5 class=""><b>Select State Delegates & Alternates</b></h5>

          <p>The number of state delegates and alternates each county is allowed determined by the MRP State Committee
            based off the results of the last election for President. </p>
          <p>Allotment is set first by congressional district, and then by county.</p>
          <p>For each state convention there are 2000 State Delegates, 2000 State Alternates. </p>
          <p>Out of those totals, Congressional districts are represented by the percent of presidential votes cast.
          </p>
          <p>If a congressional district cast 10% of the state votes, then they are alloted 10% of the total delegates
            allowed to attend the state convention. </p>

        </div>

        <div class="col-12-large ">

          <h5 class=""><b>State Delegate</b></h5>

          <p>Precinct Delegates and "Delegates At Large" are given preference at county convention to be elected by the
            other county delegates in attendence to go be sent to the state convention. However, if there are
            insufficient delegates, others who are not delegates can be elected. </p>
          <p>The state party has authorized a second group of people who are given priority for election to state if
            there are not enough delegates to go. This group is designated "Hard-Working Republicans" and are given this
            designation by members of their county for the work they do. Many people serve the party who are not
            precinct delegates, and this is a way to recognize that work.</p>

          <blockquote>
            <p>"The people are the only legitimate fountain of power." -James Madison</p>
          </blockquote>

          <p><b>Electing New County Executive Committee Members</b></p>
          <p>The counties party is run by the Executive Committee, which is elected and comprised of two groups of
            people.
            These are the statutory members and the elected members, and these groups are comprised of equal numbers.
          </p>

        </div>

      </div>
    </div>
  </div>
</section>

<!-- section 3 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">
          <h5 class=""><b>Officers</b></h5>

          <p>A convention requires several positions in order to function.</p>
          <p><b>Chair</b></p>
          <p>The Chair is responsible for leading the convention and ensuring order. The chair follows the agenda,
            appoints other convention officers, such as the Parliamentarian, Sergeant At Arms and Tellers, receives the
            committee reports, recognizes all member who bring a motion, and ensures discussion of each motion brought
            forward.</p>
          <p>There is a procedure described in MCL 168 for choosing the convention chair at each and every convention.
            The current chair of the county party opens the convention as a temporary chairman, and services in this
            capacity as the convention body elects what is known as the permanenent chair. This position, even though
            called permanent is only for the duration of the convention and ends upon adjournment.</p>
          <p>The role of the temporary chair is to run the process for electing the permanent chair of convention.
            The role of the permanent chair is to apppoint the other officers for convention and then run the convention
            accordig to the bylaws.</p>

          <p><b>Secretary</b></p>
          <p>The Secretary keeps the official record of the convention decisions, which are called "The Minutes". </p>
          <p>The Secretary will record all voting results as pronounced by the chair. </p>
          <p>The temporary chair of the convention, immediately after opening the convention, will appoint a temporary
            secretary. This secretary will fill this role until the convention body elects a permanent secretary.</p>

          <p><b>Parliamentarian</b></p>
          <p>The Parliamentarian is an advisore versed in Robert's Rules of Order, and helps ensure all laws, rules and
            parliamentary procedure are followed as the body conducts the business of convention. The parliamentarian is
            appointed by the permanent chair.</p>

          <blockquote>
            <p> "Those who own the country ought to govern it." -John Jay</p>
          </blockquote>


          <p><b>Sergeant At Arms</b></p>
          <p>The Sergeant At Arms maintains order and enforces law at county conventions, and is appointed by the
            permanent chair. </p>


          <p><b>Tellers</b></p>
          <p>The Tellers are responsible for counting all votes.</p>
          <p>This counting "standing votes", votes by "roll call", or tallying ballots. Tellers, a sufficient number,
            are appointed by the permanent chair.</p>

          <p><b>NOTE:</b></p>
          <p>Convention officers do not have to be delegates themselves. </p>
          <p>Sometimes for the sake of neutrality, it is better to have a non-delegate serve as chair.</p>
          <p>Further, delegates, even if serving as officers at convention, still have a right to vote on all matters
            that come before the convention body.</p>

        </div>

        <div class="col-12-large ">

          <h5 class=""><b>Agenda</b></h5>

          <ol>
            <li>The party chair calls the convention to order</li>
            <li>The invocation is given</li>
            <li>The pledge of allegiance is recited</li>
            <li>The temporary party chair appoints temporary officers</li>
            <li>The Call to Convention is presented </li>
            <li>The Credentials Committee Report is presented</li>
            <li>The Standing Rules Report is presented</li>
            <li>The Agenda is presented</li>
            <li>Assembled delegates elect the permanent convention chairperson and secretary</li>
            <li>Voters tally the votes and report the result to the temporary chair</li>
            <li>Temporary chair pronounces the results aloud to the assembly</li>
            <li>The permanent chairperson appoints permanent Parliamentarian, Sergeant At Arms and Tellers</li>
            <li>Oaths of Office are Administered</li>
            <li>The permanent convention chairperson makes relevant announcements, gives opportunity to present new
              business, votes are taken, and the convention is adjourned.</li>
          </ol>

        </div>

      </div>
    </div>
  </div>
</section>

<!-- section 4 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <h5 class=""><b>Duties</b></h5>
          <p>Each precinct delegate has the moral responsibility to attend and fully participate at county conventions.
          </p>
          <p>Each precinct delegate has the right to vote at county conventions. </p>
          <p>When there are fewer precinct delegates than the county has apportionment for, people can be elected at
            county convention
            to become a precinct delegate. This is called filling a vacancy. The intent is for as many people to be
            participating and voting as possible. </p>
          <p>At each county convention, the convention body may by majority vote fill vacant precinct delegate
            positions.</p>
          <p>Any person elected to fill a vacancy, is now a full precinct delegates and has the right to vote at any
            county conventions remaining in the two-year term.</p>

          <p><b>"Delegates At Large"</b></p>
          <p>"Delegates At Large" are all individuals who won the Republican party nomination in the most recent primary
            election for county government or state legislature. </p>
          <p>If the purpose of county convention is to select state delegates and alternates, then the following
            individuals are also considered "Delegates At Large". This includes the offices of governor, lieutenant
            governor, secretary of state, attorney general, state board of education, any of the three state university
            boards, and federal legislators.</p>
          <p>All current officers of the Michigan Republican Party are "Delegates At Large"</p>
          <p>It is a requirement that each "Delegates At Large" reside in the county they represent.</p>

        </div>

      </div>
    </div>
  </div>
</section>